import type { Product, WebinarRedeemableStatus } from '~/interfaces/product';
import { WEBINAR_REDEEMABLE_STATUS } from '~/interfaces/product';

const getProductVariantWebinarDetails = (product: Product) => {
  const isWebinar = product?.default_product_variant?.redeemable?.type === 'ProductRedeemables::Webinar';
  const webinarProvider = product?.default_product_variant?.redeemable?.provider;

  return {
    isWebinar,
    webinarProvider,
    // Daily.co webinars use Cal.com for booking/scheduling
    hasCalComScheduling: isWebinar && webinarProvider === 'daily_co',
    canInstantlyRedeem: isWebinar && webinarProvider === null,
  };
};

/**
 * Whether a webinar in the given status can still be purchased/registered.
 * Live webinars remain purchasable — including past the scheduled end while a
 * host is still in the room (status stays live until no host remains or the
 * status-end grace elapses). Ended/cancelled webinars cannot.
 */
export const isWebinarStatusPurchasable = (status?: WebinarRedeemableStatus): boolean =>
  status === WEBINAR_REDEEMABLE_STATUS.PENDING || status === WEBINAR_REDEEMABLE_STATUS.LIVE;

/** Whether the product's buy/register action should be disabled */
export const isProductActionDisabled = (product: Product, webinarStatus?: WebinarRedeemableStatus): boolean => {
  if (product.status === 'archived') return true;
  if (product.sold_out) return true;

  const { isWebinar } = getProductVariantWebinarDetails(product);
  if (isWebinar && !isWebinarStatusPurchasable(webinarStatus)) return true;

  return false;
};

export default getProductVariantWebinarDetails;
